
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teachers/lessons/[lessonSlug]/downloads",
      function () {
        return require("private-next-pages/teachers/lessons/[lessonSlug]/downloads.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teachers/lessons/[lessonSlug]/downloads"])
      });
    }
  